













































































































import ContentWrapper from '@/components/ContentWrapper.vue';
import { InsertGroupLevelAttributeValueDTO } from '@/jbi-shared/dto/jaas-group-level-attributes.dtos';
import { CreateNewGroupDTO } from '@/jbi-shared/dto/jaas-groups.dtos';
import {
  CreateCourseDTO,
  CreateCourseMasterDTO,
  CreateCourseResponse,
  UpsertCourseModuleDTO
} from '@/jbi-shared/dto/jtms.dtos';
import { GroupLevelAttributeValue } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import { deepCopy } from '@/jbi-shared/util/deep-copy.util';
import {
  GetSignedUrlForUploadResponsePayload,
  GroupLevelAttributeValuePayload
} from '@/store/modules/admin/types/group-level-attribute.types';
import {
  MasterGroupsResponseDTO,
  ProtectedGroupTypes
} from '@/store/modules/admin/types/group.types';
import { CourseModuleComponentItem } from '@/store/modules/jtms/course-module/course-module.types';
import {
  CourseCreateAndUpdateButtonEventTypes,
  CourseRegistrationConfig,
  CourseTypeDTO,
  CourseTypeOption,
  CreateCourseTrainerDTO
} from '@/store/modules/jtms/course/course.types';
import { RootState } from '@/store/store';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { convertToAttributeOptionsWithValue } from '@/utils/group-level-attribute.util';
import { MemberObject } from '@/utils/group.util';
import { convertCourseModuleComponentItem } from '@/utils/jtms-utils';
import { DialogProgrammatic, ToastProgrammatic } from 'buefy';
import delay from 'delay';
import { ValidationObserver, ValidationObserverInstance } from 'vee-validate';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import PublishDraftCourseModal from '../EditCourses/components/PublishDraftCourseModal.vue';
import CourseCreationSubmitButtons from './components/CourseCreationSubmitButtons.vue';
import CourseNameAndTypeForm from './components/CourseNameAndTypeForm.vue';
import CourseSettingsToggles from './components/CourseSettingsToggles.vue';
import CourseLevelAttributeTab from './CourseLevelAttributes/CourseLevelAttribute.tab.vue';
import CourseModulesTab from './CourseModules/CourseModules.tab.vue';

@Component({
  components: {
    ValidationObserver,
    ContentWrapper,
    CourseNameAndTypeForm,
    CourseLevelAttributeTab,
    CourseModulesTab,
    CourseSettingsToggles,
    CourseCreationSubmitButtons
  }
})
export default class CreateCoursesPage extends Vue {
  currentActiveTab: number = 0;
  // disableModulesTab: boolean = true;
  name = '';
  type: CourseTypeOption | null = null;
  createCourseLoading: boolean = false;
  createCourseLevelAttributeLoading: boolean = false;

  createAndPublishCoursePayload: CourseRegistrationConfig | null = null;
  parentGroup: MasterGroupsResponseDTO | null = null;
  trainerIds: number[] = [];
  protectedTypes: ProtectedGroupTypes[] = [];
  agreementFiles: Array<File | GetSignedUrlForUploadResponsePayload> = [];
  membersData: MemberObject[] = [];

  isDraftCourse = false;
  isMemberDataValid = true;
  nameAndTypeFieldsHasValues: boolean = !!this.name && !!this.type;

  activeGroupAttributes: GroupLevelAttributeValue[] = [];
  deleteGroupAttributes: GroupLevelAttributeValue[] = [];

  // COURSE MODULE RELATED VARIABLES
  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.activeCourseModules
  )
  activeCourseModules!: CourseModuleComponentItem[];

  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.deletedCourseModules
  )
  deletedCourseModules!: CourseModuleComponentItem[];

  @State(
    (state: RootState) =>
      state.courseModule.courseModulesTabState.courseModuleFormHasError
  )
  courseModuleFormHasError!: boolean;

  @State((state: RootState) => state.course.createdDraftCourseId)
  createdDraftCourseId!: number;

  // FORM VALIDATION
  courseLevelAttributeFormHasError: boolean = false;

  @Action('course/createNewCourse')
  public createNewCourse!: (
    payload: CreateCourseMasterDTO
  ) => Promise<CreateCourseResponse>;

  @Action('course/createDraftCourse')
  public createDraftCourse!: (
    payload: CreateCourseMasterDTO
  ) => Promise<CreateCourseResponse>;

  @Action('admin/createGroupLevelAttributesValues')
  createGroupLevelAttributeValues!: (
    payload: GroupLevelAttributeValuePayload
  ) => Promise<void>;

  @Action('course/getCourseTypes')
  getCourseTypes!: () => Promise<CourseTypeDTO[]>;

  @Action('course/storeSelectedCourseType')
  storeSelectedCourseType!: (payload?: CourseTypeOption) => void;

  @Action('courseModule/clearActiveCourseModules')
  clearActiveCourseModules!: () => void;

  @Action('courseModule/clearDeletedCourseModules')
  clearDeletedCourseModules!: () => void;

  @Action('courseModule/updateCourseModuleFormError')
  updateCourseModuleFormError!: (payload: boolean) => void;

  @State((state: RootState) => state.course.courseCreationState.hasModules)
  hasModules!: boolean;

  @State((state: RootState) => state.course.courseCreationState.isFreeCourse)
  isFreeCourse!: boolean;

  @State((state: RootState) => state.course.courseTypes)
  courseTypes!: CourseTypeDTO[];

  @State(({ course }: RootState) => course.apiState.getCourseTypes.success)
  getCourseTypesSuccess!: ApiState;

  @State(({ course }: RootState) => course.apiState.createNewCourse)
  createNewCourseApiState!: ApiState;

  @State(({ course }: RootState) => course.apiState.createDraftCourse)
  createDraftCourseApiState!: ApiState;

  get isLoadingActive(): boolean {
    return (
      (this.courseTypes && this.courseTypes.length === 0) ||
      this.createNewCourseApiState.loading ||
      this.createCourseLevelAttributeLoading
    );
  }

  get courseTypeOptions(): CourseTypeOption[] {
    return Object.values(this.courseTypes).map((courseType: CourseTypeDTO) => ({
      id: courseType.id,
      name: courseType.name
    }));
  }

  get groupId() {
    return this.$route.params.groupId;
  }

  get shouldDisableAttributes() {
    return !this.name || !this.type || this.createDraftCourseApiState.error;
  }

  created() {
    if (!this.courseTypes) {
      this.getCourseTypes();
    }
  }

  mounted() {
    this.clearActiveCourseModules();
    this.clearDeletedCourseModules();
    this.storeSelectedCourseType(undefined);
  }

  async handleCreateCourse(eventType: CourseCreateAndUpdateButtonEventTypes) {
    this.createCourseLoading = true;

    switch (eventType) {
      case CourseCreateAndUpdateButtonEventTypes.SAVE_AS_DRAFT:
        await this.createCourse(true);
        break;
      case CourseCreateAndUpdateButtonEventTypes.CREATE_AND_PUBLISH:
        this.openPublishDraftCourseModal();
        break;
      default:
        break;
    }
  }

  async triggerValidationObserver() {
    const rootValidationObserver = this.$refs
      .rootValidationObserver as ValidationObserverInstance;

    if ((await rootValidationObserver.validate()) === false) {
      this.createCourseLoading = false;
      const isNameEmpty = !this.name?.trim();
      const isTypeEmpty = !this.type;
      const GLAsEmpty = this.activeGroupAttributes.length === 0;

      let message = 'Please fill in all the required fields';

      if (isNameEmpty) {
        message = 'Name is required';
      } else if (isTypeEmpty) {
        message = 'Course type is required';
      } else if (GLAsEmpty) {
        message = 'Group Level Attributes array cannot be empty';
      }

      return DialogProgrammatic.alert({
        title: `Error`,
        message: `<p class="subtitle">${message}<p>`,
        type: 'is-primary'
      });
    }
  }

  async createCourse(saveAsDraft: boolean) {
    // Trigger fields wrapped with ValidationProvider
    await this.triggerValidationObserver();

    try {
      // Assign to local value
      this.isDraftCourse = saveAsDraft;

      const groupPayload: CreateNewGroupDTO = {
        name: this.name,
        attributesSpecs: [],
        // Mapping is done here because agreements is cannot be initialized as an empty array
        agreements: this.agreementFiles.map((file) => ({
          fileUri: (file as GetSignedUrlForUploadResponsePayload).storageUri,
          fileName: (file as GetSignedUrlForUploadResponsePayload).fileName
        })),
        /**
         * Course Members cannot be added to courses from the Course Creation UI
         * hence there is not necessary to initialize the array with member data
         * or perform members data sanitization at this stage.
         */
        userAttributesArr: [],
        // Same type as primary org, assigned in backend to minimize frontend api calls
        types: [],
        // No need to notify members because members cannot be added in this UI
        notify: false,
        emailDomains: [],
        // Same protected group as primary org, assigned in backend to minimize frontend api calls
        protectedGroup: null
      };

      let coursePayload: CreateCourseDTO = {
        // primaryOrganisationId: 1,
        primaryOrganisationId: this.parentGroup ? this.parentGroup.id : 1458,
        courseTypeId: this.type!.id as number,
        saveAsDraft
      };

      if (this.createAndPublishCoursePayload) {
        const {
          visibility,
          openForRegistration,
          requireRegistrationConfirmation
        } = this.createAndPublishCoursePayload;

        coursePayload = {
          ...coursePayload,
          visibility,
          openForRegistration,
          requireRegistrationConfirmation
        };
      }

      const courseTrainerPayload: CreateCourseTrainerDTO = {
        selectedTrainerIds: this.trainerIds
      };

      const glaValuesPayload: InsertGroupLevelAttributeValueDTO = {
        attributeValues: convertToAttributeOptionsWithValue(
          this.activeGroupAttributes
        )
      };

      // Construct course module payload only if modules are enabled
      let courseModulePayload: UpsertCourseModuleDTO;
      if (this.hasModules) {
        courseModulePayload = {
          moduleComponents: {
            active: convertCourseModuleComponentItem(this.activeCourseModules)
          }
        };
      }

      const masterPayload: CreateCourseMasterDTO = {
        createGroupPayload: groupPayload,
        createCoursePayload: coursePayload,
        createGLAPayload: glaValuesPayload,
        createCourseTrainerPayload: courseTrainerPayload,
        createCourseModulePayload: this.hasModules
          ? courseModulePayload!
          : undefined
      };

      // `courseId` returned for page redirection
      const { courseId } = await this.createNewCourse(masterPayload);

      // TODO: Implement template loading, blocked by course template completion
    } catch (error: any) {
      // Catches any errors from the frontend
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(error?.response?.data?.message || error),
        duration: 5000
      });
    }
  }

  async handleDraftCourseCreation() {
    await this.triggerValidationObserver();
    try {
      const groupPayload: CreateNewGroupDTO = {
        name: this.name,
        attributesSpecs: [],
        // Mapping is done here because agreements is cannot be initialized as an empty array
        agreements: this.agreementFiles.map((file) => ({
          fileUri: (file as GetSignedUrlForUploadResponsePayload).storageUri,
          fileName: (file as GetSignedUrlForUploadResponsePayload).fileName
        })),
        /**
         * Course Members cannot be added to courses from the Course Creation UI
         * hence there is not necessary to initialize the array with member data
         * or perform members data sanitization at this stage.
         */
        userAttributesArr: [],
        // Same type as primary org, assigned in backend to minimize frontend api calls
        types: [],
        // No need to notify members because members cannot be added in this UI
        notify: false,
        emailDomains: [],
        // Same protected group as primary org, assigned in backend to minimize frontend api calls
        protectedGroup: null
      };

      const coursePayload: CreateCourseDTO = {
        courseTypeId: this.type!.id as number,
        saveAsDraft: true
      };

      const glaValuesPayload: InsertGroupLevelAttributeValueDTO = {
        attributeValues: convertToAttributeOptionsWithValue(
          this.activeGroupAttributes
        )
      };

      // Construct course module payload only if modules are enabled
      let courseModulePayload: UpsertCourseModuleDTO;
      if (this.hasModules) {
        courseModulePayload = {
          moduleComponents: {
            active: convertCourseModuleComponentItem(this.activeCourseModules)
          }
        };
      }

      const masterPayload: CreateCourseMasterDTO = {
        createGroupPayload: groupPayload,
        createCoursePayload: coursePayload,
        createGLAPayload: glaValuesPayload,
        createCourseModulePayload: this.hasModules
          ? courseModulePayload!
          : undefined
      };

      this.createDraftCourse(masterPayload);
    } catch (error: any) {
      // Catches any errors from the frontend as a failsafe
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(error?.response?.data?.message || error),
        duration: 5000
      });
    }
  }

  handleUpdateGroupLevelAttributeValues(
    activeValues: GroupLevelAttributeValue[],
    deleteValues: GroupLevelAttributeValue[],
    error: boolean
  ) {
    this.activeGroupAttributes = activeValues;
    this.deleteGroupAttributes = deleteValues;
    this.courseLevelAttributeFormHasError = error;
  }

  courseCreationFormHasError(
    isValidationObserverInvalid: boolean,
    isValidationObserverValidated: boolean
  ): boolean {
    return (
      isValidationObserverInvalid ||
      !isValidationObserverValidated ||
      this.courseLevelAttributeFormHasError ||
      this.courseModuleFormHasError
    );
  }

  openPublishDraftCourseModal() {
    this.$buefy.modal.open({
      parent: this,
      component: PublishDraftCourseModal,
      hasModalCard: true, // added to prevent breaking on mobile
      trapFocus: true,
      fullScreen: false,
      canCancel: true,
      props: {
        groupDetails: this.name,
        attributes: deepCopy(this.activeGroupAttributes)
      },
      events: {
        createAndPublishCourse: async (payload: CourseRegistrationConfig) => {
          this.createAndPublishCoursePayload = payload;
          await this.createCourse(false);
        }
      }
    });
  }

  assignParentGroup(data: MasterGroupsResponseDTO) {
    this.parentGroup = data;
  }

  assignTrainerIds(data: number[]) {
    this.trainerIds = data;
  }

  @Watch('name')
  @Watch('type', { deep: true })
  @Debounce(2000)
  onNameAndTypesHasValuesA() {
    // Only invoke API call once
    if (this.name && this.type) {
      this.handleDraftCourseCreation();
    }
  }

  async handleRedirect() {
    // Redirect immediately if no values were provided
    if (this.shouldDisableAttributes) {
      this.redirectToDashboardOverview();
      return;
    }

    const dialogElem: Vue = this.$buefy.dialog.confirm({
      title: `Discard Course Creation`,
      message: `All data entered will be lost once you exit this page`,
      confirmText: 'Cancel',
      canCancel: ['button'],
      onConfirm: () => undefined,
      cancelText: 'Exit',
      onCancel: () => this.redirectToDashboardOverview()
    });

    while (!dialogElem.$el?.querySelector) {
      await delay(50);
    }
    const cancelBtn = dialogElem.$el?.querySelector?.(
      `.modal-card > footer > button:first-child`
    );
    cancelBtn?.classList?.add?.(`is-red`);
  }

  redirectToDashboardOverview() {
    this.$router.replace({ name: 'dashboard-overview' });
  }

  @Watch('hasModules')
  onDisableModuleTab() {
    if (!this.hasModules) {
      // Ensure all payloads are empty if "No modules" is selected
      this.clearActiveCourseModules();
      this.clearDeletedCourseModules();
      this.updateCourseModuleFormError(false);

      // Handle redirection to 1st tab if user was on "Modules" tab
      // and switched module radio button selection
      if (this.currentActiveTab === 1) {
        this.currentActiveTab = 0;
      }
    }
  }

  @Watch('createNewCourseApiState', { deep: true })
  onCreateNewCourseApiStateChanged(state: ApiState) {
    if (state.success) {
      if (this.isDraftCourse) {
        ToastProgrammatic.open({
          queue: true,
          type: 'is-dark',
          position: 'is-top',
          message: `Course successfully created and saved as draft`
        });
      } else {
        ToastProgrammatic.open({
          queue: true,
          type: 'is-dark',
          position: 'is-top',
          message: `Course successfully created and published`
        });
      }
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 5000
      });
    }
  }

  @Watch('createDraftCourseApiState', { deep: true })
  onCreateDraftCourseApiStateChanged(state: ApiState) {
    if (state.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: `Course successfully created and saved as draft`
      });

      this.$router.push({
        name: 'course-settings',
        params: {
          courseId: String(this.createdDraftCourseId)
        }
      });
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 3000
      });
    }
  }

  @Watch('isFreeCourse')
  onIsFreeCourseToggle() {
    const pricingIndex = this.hasModules ? 2 : 1;
    if (this.isFreeCourse && this.currentActiveTab === pricingIndex) {
      this.currentActiveTab = 0;
    }
  }

  @Watch('type')
  onTypeSelected() {
    this.storeSelectedCourseType(this.type!);
  }
}
